import { FormProvider, useForm } from 'react-hook-form';
import { InputHookForm } from '../../Common/Form/input-with-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { metadataSchema } from './schema';
import { MenuHookForm } from '../../Common/Form/menu-with-hook-form';
import Button from '../../Button';
import { useEffect, useState } from 'react';
import ArrowRightIcon from '../../../assets/arrow-right-white-icon.svg';
import { TextAreaHookForm } from '../../Common/Form/textarea-hook-form';
import FormInputCounter from './InputCountCharacter/form-input-counter.component';
import {
  updateRequest,
  fetchRequestContentTypes,
  fetchRequestDetail
} from '../../../apis/request.api';
import { useNavigate } from 'react-router-dom';
import EditRequestModal from './edit-request-modal.component';
import { useToast } from '@chakra-ui/react';
import { TooltipComponent } from '../../Tooltip';
import InformIcon from '../../../assets/inform-gray-icon.svg';
import ToastBtnMessage from '../../ToastBtnMessage';

const EQUITY_PERCENTAGE_TOOLTIP =
  "Share a percentage of the article's equity with the contributor. The contributor can also propose a different percentage in the form.";

const EditRequestEnterMetadataComponent = () => {
  const [listContentType, setListContentType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState('');
  const [createdRequestId, setCreatedRequestId] = useState();
  const [requestInfo, setRequestInfo] = useState({});
  const toast = useToast();

  const navigate = useNavigate();

  const methods = useForm({
    resolver: yupResolver(metadataSchema)
  });

  const onSubmit = async (formValue) => {
    try {
      await updateRequest(requestInfo.id, {
        contentTypeIds: formValue.contentTypeIds.map((contentType) => contentType.id),
        description: formValue.description,
        equityPercentage: Number(formValue.equityPercentage),
        title: formValue.title
      }).then((response) => {
        setCreatedRequestId(response?.id);
        setModal('update-success');
      });
    } catch (error) {
      console.log(error);
      toast({
        render: () => (
          <ToastBtnMessage
            title={'Create request failed'}
            isError={true}
            color="jet-black"
            isHiddenButton
          />
        ),
        status: 'error',
        duration: 2000,
        isClosable: true,
        position: 'top-right'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBackToRequestScreen = () => {
    navigate('/article/manage?tab=requests');
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const topicsRes = await fetchRequestContentTypes();
        if (topicsRes) setListContentType(topicsRes);
      } catch (error) {
        console.log(error);
      }
    };

    const getRequestDetail = async () => {
      try {
        const match = window.location.href.match(/\/request\/([^\/]+)\//);
        const requestId = match ? match[1] : null;

        const requestRes = await fetchRequestDetail(requestId);
        if (requestRes) {
          setRequestInfo(requestRes);

          // intial yup values
          methods.setValue('title', requestRes.title);
          methods.setValue('description', requestRes.description);
          methods.setValue('equityPercentage', requestRes.equityPercentage);
          methods.setValue(
            'contentTypeIds',
            requestRes.contentTypes.map((contentType) => contentType.id)
          );
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
    getRequestDetail();
  }, []);

  return (
    <div className="mb-[90px] md:mb-[200px] max-w-[592px] mx-auto">
      <div>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-4 w-full">
              <FormInputCounter
                name="title"
                placeholder="ex.: Image of a dog"
                label="Request title"
                maxLength={100}
                component={InputHookForm}
                defaultValue={requestInfo?.title}
              />
              <FormInputCounter
                component={TextAreaHookForm}
                css={{
                  '&::-webkit-scrollbar': {
                    display: 'none'
                  }
                }}
                name="description"
                placeholder="Write description"
                defaultValue={requestInfo?.description}
                label="Description"
                maxLength={2000}
              />
              {/* Equitity Percentage */}
              <div>
                <div className="flex items-center mb-[12px]">
                  <p className="mr-1">Equity percentage </p>
                  <TooltipComponent Icon={InformIcon} description={EQUITY_PERCENTAGE_TOOLTIP} />
                </div>
                <FormInputCounter
                  name="equityPercentage"
                  placeholder="ex: 2%, 5%..."
                  defaultValue={requestInfo?.equityPercentage}
                  label=""
                  component={InputHookForm}
                  isShowRange={false}
                  isOptional={true}
                />
              </div>
              <MenuHookForm
                name="contentTypeIds"
                label="Content Type"
                isShowCheckBox
                placeholder="Image, Video"
                data={listContentType || []}
                defaultValue={requestInfo.contentTypes}
              />
            </div>
            <div className="bg-white flex flex-row gap-3 justify-end border-t-[1px] border-solid border-04-anti-flash-white fixed left-0 bottom-0 z-20 p-4 w-full">
              <Button variant="outline" onClick={handleBackToRequestScreen}>
                Discard
              </Button>
              <Button type="submit" isLoading={loading}>
                Save changes
                <img src={ArrowRightIcon} alt="" className="ml-2" />
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
      {modal === 'update-success' ? (
        <EditRequestModal
          isOpen
          title="Request Updated!"
          shareUrl={`${process.env.REACT_APP_NEWSLETTER_URL}request/${createdRequestId}/detail`}
          onClose={handleBackToRequestScreen}
          onSubmit={handleBackToRequestScreen}
          titleBtn="View My Requests"
        />
      ) : null}
    </div>
  );
};

export default EditRequestEnterMetadataComponent;
